/* PreviewBannerRenderer.js */

"use strict";
const uiCore = require("@gluenetworks/steve_ui_core");
// const CheckboxControl = uiCore.Control.Boolean.InputCheckbox;
const ButtonControl = uiCore.Control.Action.Button;
// const InputTextControl = uiCore.Control.Textfield.InputText;

class PreviewBannerRenderer {
    constructor(model, initialData) {
        this._model = model;
        this._rootElem = this._createRootElement();
        this._headerEl = document.createElement("h2");
        this._headerEl.innerText = "Banner Preview";
        this._previewContainer = document.createElement("div");
        this._previewContainer.classList.add("preview-banner");
        this._messageContainer = document.createElement("div");
        this._messageContainer.classList.add("message");
        this._actionsContainer = document.createElement("div");
        this._actionsContainer.classList.add("actions");

        this._acceptButton = new ButtonControl({
            active: true,
            class: "accept-btn",
            darkTheme: true,
            label: "Accept"
        });
        this._refusalButton = new ButtonControl({
            class: "refuse-btn",
            darkTheme: true,
            label: "Cancel"
        });

        this._actionsContainer.appendChild(this._refusalButton.renderer._rootElem);
        this._actionsContainer.appendChild(this._acceptButton.renderer._rootElem);

        /* form controls */
        this.saveButton = new ButtonControl({
            label: "Close",
            darkTheme: true,
            disabled: false,
            class: "preview-close"
        });



        /**/
        if (initialData) {
            this._setData(initialData);
        }

        this._registerListeners();
        this.render();
    }

    get rootElement() {
        return this.getRootElement();
    }

    get model() {
        return this.getModel();
    }

    /*******************************************/
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    render() {
        if (this._renderProm === null) {
            return Promise.resolve();
        }
        this._renderProm = this._renderProm || this._render();
        return this._renderProm;
    }

    shutdown() {
        if (this._shutdownProm === null) {
            return Promise.resolve();
        }
        this._shutdownProm = this._shutdownProm || this._shutdown();
        return this._shutdownProm;
    }

    getRootElement() {
        return this._rootElem;
    }

    getModel() {
        return this._model;
    }

    /********************************************/
    /* END PUBLIC COMPONENT RENDERER METHODS */
    /* START PRIVATE COMPONENT RENDERER METHODS */

    /********************************************/

    _registerListeners() {
        this._model.on("Data", (this._onData = this._onData.bind(this)));
        this.saveButton.on("UserClick", this.submitAction.bind(this));
        this._model.on("Error", this._onError.bind(this));
    }

    _unregisterListeners() {
        this._model.removeListener("Data", this._onData);
        this.saveButton.removeAllListeners("UserClick");
        this._model.removeAllListeners("Error");
    }

    _render() {
        const root = document.createDocumentFragment();
        this._rootElem.innerHTML = "";
        this._rootElem.appendChild(this._headerEl);
        this._rootElem.appendChild(this._previewContainer);
        this._previewContainer.appendChild(this._messageContainer);
        this._previewContainer.appendChild(this._actionsContainer);
        this._rootElem.appendChild(this.saveButton.renderer._rootElem);
        return new Promise((resolve /*,reject*/) => {
            this._rootElem.appendChild(root);
            this._makeAnchorsNonNavigable();
            resolve();
        });
    }

    _shutdown() {
        this._unregisterListeners();
        this._rootElem.remove();
        this._rootElem = null;

        return Promise.all([
            this.saveButton.shutdown()
        ])
            .then(() => {
                this._model = null;
                this._shutdownProm = null;
                this._renderProm = null;
                this._headerEl = undefined;
            })
            .catch((error) => {
                console.log(`${this.constructor.name}: error in shutdown`);
                console.error(error);
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PRIVATE RENDERER METHODS */

    /*******************************************/

    _createRootElement() {
        const rootElement = document.createElement("div");
        rootElement.classList.add("banner-preview", "modal_feedback_container");
        rootElement.component = this._model;
        return rootElement;
    }

    /*******************************************/
    /* END PRIVATE RENDERER METHODS  */
    /* START HANDLER METHODS */
    /*******************************************/
    _onData(data = {}) {
        this._setData(data);
    }

    _onError(errorMsg) {
        this._setError(errorMsg);
        this._checkSaveButton(false);
    }

    submitAction() {
        this._model.closePopUp(false);
    }
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    _setData(data) {
        this._messageContainer.innerHTML = data.text;
        this._acceptButton.setLabel(data.acceptButtonLabel);
        this._refusalButton.setLabel(data.refusalButtonLabel);
    }

    _makeAnchorsNonNavigable() {
        const anchorElsList = this._messageContainer.querySelectorAll("a");
        anchorElsList.forEach(anchorEl => {
            anchorEl.setAttribute("target", "_blank");
        });
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = PreviewBannerRenderer;
